@if (isExpectFundLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
<div class="receipt-container" [class.fullscreen-mode]="!isDialogOpen()">
    <div mat-dialog-title class="title">
        <span class="heading">Expected Funds</span>
        @if (isDialogOpen()) {
        <div class="title-actions">
            <button type="button" mat-icon-button (click)="openInNewTab()" class="new-tab">
                <mat-icon>open_in_new</mat-icon>
            </button>
            <button type="button" mat-dialog-close mat-icon-button (click)="closeDialog()">
                <mat-icon class="close-icon-color">cancel</mat-icon>
            </button>
        </div>
        }
    </div>

    <div #dialogContent mat-dialog-content>
        <form [formGroup]="ExpectFundForm">
            <div class="header-content">
                @if (showReturnReason) {
                <mat-form-field subscriptSizing="dynamic" class="fullLength">
                    <mat-label style="color: red;">Rejected Reason</mat-label>
                    <input matInput formControlName="returnReason" readonly>
                </mat-form-field>
                }
                <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Matter</mat-label>
                    <input readonly matInput formControlName="matterName" />
                </mat-form-field>
                @if (isDateTransactionVisible) {
                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Transaction Date</mat-label>
                        <input matInput
                               [matDatepicker]="dateTransactionPicker"
                               formControlName="dateTransaction"
                               placeholder="dd/MM/yyyy"  [max]="currentDate"/>
                        <mat-datepicker-toggle matSuffix [for]="dateTransactionPicker" />
                        <mat-datepicker #dateTransactionPicker />
                        @if (ExpectFundForm.get('dateTransaction')?.touched &&
                        ExpectFundForm.get('dateTransaction')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Transaction Time</mat-label>
                        <input matInput
                               type="time"
                               formControlName="transactionTime" />
                    </mat-form-field>
                </div>
                }

                @if (showLinkToOpenMatter()) {
                <div class="sticky-actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterUrl" target="_blank" rel="noopener noreferrer">
                            Open Matter in Actionstep ({{ matterNo }})
                        </a>
                        <button type="button" mat-icon-button class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterUrl"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }
            </div>

            <mat-tab-group class="request-tab" color="accent" [animationDuration]="'0ms'" [disableRipple]="true" dynamicHeight="true">
                <mat-tab label="Request Details">
                    <div [ngClass]="{
                            'tab-content-wrapper-return': isDialogOpen() && showReturnReason,
                            'tab-content-wrapper': isDialogOpen() && !showReturnReason,
                            'extended-tab-content-return-wrapper': !isDialogOpen() && showReturnReason,
                            'extended-tab-content-wrapper': !isDialogOpen() && !showReturnReason
                         }">
                        <div class="form-content">
                            <mat-form-field class="fullLength">
                                <mat-label>Payment method</mat-label>
                                <mat-select formControlName="paymentMethod" (selectionChange)="onPaymentMethodChange()">
                                    @for (method of paymentMethodDropdown; track method) {
                                    <mat-option [value]="method">{{ method }}</mat-option>
                                    }
                                </mat-select>
                                <mat-error *ngIf="ExpectFundForm.get('paymentMethod')?.invalid">Please select a valid payment method.</mat-error>
                            </mat-form-field>

                            @if (ExpectFundForm.get('paymentMethod')?.value === 'Electronic funds transfer' && isPaymentMethodFieldsVisible) {
                            <fieldset>
                                <legend>Electronic funds transfer details</legend>
                                @if (showReceiptType) {
                                <mat-form-field>
                                    <mat-label>Receipt Type</mat-label>
                                    <mat-select formControlName="receiptType">
                                        @for (type of receiptTypeDropdown; track type) {
                                        <mat-option [value]="type">{{ type }}</mat-option>
                                        }
                                    </mat-select>
                                    <mat-error>Please select a receipt type.</mat-error>
                                </mat-form-field>
                                }
                                <mat-form-field>
                                    <mat-label>Transaction Reference</mat-label>
                                    <input matInput formControlName="transactionReference" [readonly]="!isAccountsStage" />
                                    <mat-error *ngIf="ExpectFundForm.get('transactionReference')?.hasError('required')">
                                        Transaction Reference is required.
                                    </mat-error>
                                </mat-form-field>
                            </fieldset>
                            }

                            @if (ExpectFundForm.get('paymentMethod')?.value === 'Cheque' && isPaymentMethodFieldsVisible) {
                            <fieldset>
                                <legend>Cheque Details</legend>
                                <mat-form-field>
                                    <mat-label>Cheque Date</mat-label>
                                    <input matInput
                                           [matDatepicker]="chequeDatePicker"
                                           placeholder="Date of payment"
                                           formControlName="checkDate"
                                           [readonly]="!isAccountsStage" />
                                    <mat-error *ngIf="ExpectFundForm.get('checkDate')?.invalid && ExpectFundForm.get('checkDate')?.touched">Please select a payment date.</mat-error>
                                    <mat-datepicker-toggle matSuffix [for]="chequeDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #chequeDatePicker></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Cheque From</mat-label>
                                    <input matInput formControlName="checkFrom" [readonly]="!isAccountsStage" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Cheque Number</mat-label>
                                    <input matInput formControlName="checkNumber" [readonly]="!isAccountsStage" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Cheque Memo</mat-label>
                                    <input matInput formControlName="checkMemo" [readonly]="!isAccountsStage" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Cheque Bank Name</mat-label>
                                    <input matInput formControlName="checkBankName" [readonly]="!isAccountsStage" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Cheque Bank Branch</mat-label>
                                    <input matInput formControlName="checkBankBranch" [readonly]="!isAccountsStage" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Transaction Reference</mat-label>
                                    <input matInput formControlName="transactionReference" [readonly]="!isAccountsStage" />
                                    @if (ExpectFundForm.get('transactionReference')?.hasError('required')) {
                                    <mat-error>
                                        Transaction Reference is required.
                                    </mat-error>
                                    }
                                </mat-form-field>
                            </fieldset>
                            }

                            @if (ExpectFundForm.get('paymentMethod')?.value === 'Credit Card' && isPaymentMethodFieldsVisible) {
                            <fieldset>
                                <legend>Credit Card Details</legend>
                                <mat-form-field>
                                    <mat-label>Last 4 Numbers</mat-label>
                                    <input matInput formControlName="lastFourNumbers" [readonly]="!isAccountsStage" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Authorization Number</mat-label>
                                    <input matInput formControlName="authorizationNumber" [readonly]="!isAccountsStage" />
                                </mat-form-field>
                            </fieldset>
                            }

                            <mat-form-field class="fullLength">
                                <mat-label>Are monies coming from client?</mat-label>
                                <mat-select formControlName="moniesCheckbox">
                                    <mat-option [value]="true">Yes</mat-option>
                                    <mat-option [value]="false">No</mat-option>
                                </mat-select>
                            </mat-form-field>

                            @if (showPayeeSelect) {
                            <mat-form-field>
                                <mat-label>Payee</mat-label>
                                <mat-select multiple required panelClass="sw-multi-select-panel" [formControl]="payeeClients"
                                            [errorStateMatcher]="payeeErrorMatcher"
                                            (selectionChange)="onPayeeClientsChange()"
                                            (openedChange)="onPayeeSelectOpened($event)">
                                    @for (name of clientOptions; track name) {
                                    <mat-option [value]="name">{{ name }}</mat-option>
                                    }
                                </mat-select>
                                <mat-error>Please select at least one payee.</mat-error>
                            </mat-form-field>
                            } @else {
                            <mat-form-field>
                                <mat-label>Payee</mat-label>
                                <input matInput formControlName="name" [readonly]="!canEditFields" />
                                @if (isLoading) {
                                <mat-progress-spinner class="spinner-padding" matSuffix
                                                      mode="indeterminate" diameter="20" strokeWidth="3" color="accent">
                                </mat-progress-spinner>
                                }
                            </mat-form-field>
                            }

                            <mat-form-field>
                                <mat-label>Reason for Expected Funds</mat-label>
                                <input matInput formControlName="reason" [readonly]="!canEditFields" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Amount</mat-label>
                                <input matInput formControlName="amount" [readonly]="!canEditFields" appCurrencyInput />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Currency</mat-label>
                                <mat-select formControlName="currency">
                                    <mat-option *ngFor="let c of currencyDropdown" [value]="c.id">
                                        {{ c.currencyCode }} - {{ c.symbol }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>Please select a currency code.</mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Client Bank</mat-label>
                                <mat-select formControlName="clientBankAccount">
                                    @for (account of filteredBankAccounts; track account.accountId) {
                                    <mat-option [value]="account">
                                        {{ account.accountId }} - {{ account.description }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            @if (showLinkToOpenMatter()) {
                            <div class="actionstep-matter-overview">
                                <div class="link-wrapper">
                                    <a [href]="actionstepMatterOverviewUrl" target="_blank" rel="noopener noreferrer">
                                        Open Actionstep Matter ({{ matterNo }}) Overview
                                    </a>
                                    <button type="button" mat-icon-button class="small-copy-btn"
                                            [cdkCopyToClipboard]="actionstepMatterOverviewUrl"
                                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                                            matTooltip="Copy link to clipboard"
                                            matTooltipPosition="below">
                                        <mat-icon>content_copy</mat-icon>
                                    </button>
                                </div>
                                <div class="warning-box">
                                    You must be logged into Actionstep under the same jurisdiction.
                                </div>
                            </div>
                            }

                            <mat-form-field>
                                <mat-label>Notes to Accounts</mat-label>
                                <input matInput formControlName="notesToAccounts" [readonly]="!canEditFields" />
                            </mat-form-field>

                            @if (ExpectFundForm.get('dateAuthorized')?.value) {
                            <mat-form-field color="accent">
                                <mat-label>Date authorised</mat-label>
                                <input matInput
                                       [matDatepicker]="dateAuthPicker"
                                       placeholder="Date authorised"
                                       formControlName="dateAuthorized" />
                                <mat-datepicker-toggle matSuffix color="mat-accent" [for]="dateAuthPicker"></mat-datepicker-toggle>
                                <mat-datepicker #dateAuthPicker></mat-datepicker>
                            </mat-form-field>
                            }

                            <div class="date-time-row">
                                <mat-form-field color="accent" class="date-field">
                                    <mat-label>Requested Date</mat-label>
                                    <input matInput
                                           [matDatepicker]="dateRequestedPicker"
                                           formControlName="dateRequested"
                                           placeholder="dd/MM/yyyy" />
                                    <mat-datepicker-toggle matSuffix [for]="dateRequestedPicker" />
                                    <mat-datepicker #dateRequestedPicker />
                                </mat-form-field>

                                <mat-form-field color="accent" class="time-field">
                                    <mat-label>Requested Time</mat-label>
                                    <input matInput
                                           type="time"
                                           formControlName="requestedTime" />
                                </mat-form-field>
                            </div>

                            <mat-form-field>
                                <mat-label>Partner authorising</mat-label>
                                <input readonly matInput formControlName="partnerAuthorising" />
                            </mat-form-field>


                            <mat-form-field appearance="fill" class="upload-doc">
                                <mat-label>Files to upload</mat-label>
                                <input matInput [value]="displayFile.join(', ')" placeholder="Please select a file">
                                <button type="button" (click)="fileInput.click()" mat-icon-button matSuffix>
                                    <mat-icon>upload_file</mat-icon>
                                </button>
                                @if (displayFile.length > 0) {
                                <button type="button" (click)="clearUpload(fileInput)" mat-icon-button matSuffix>
                                    <mat-icon>clear</mat-icon>
                                </button>
                                }
                                <input type="file" id="fileInput" (change)="onFilesSelected($event.target)" #fileInput multiple hidden>
                            </mat-form-field>

                            @if (expectFundData.comments?.length) {
                            @for (item of expectFundData.comments; let i = $index; track i) {
                            <mat-form-field>
                                <mat-label>{{ i + 1 }}. {{ StagesLabel[item.stageId ?? item.currentStageId!] }}</mat-label>
                                <textarea matInput [value]="item.comment" readonly></textarea>
                            </mat-form-field>
                            }
                            }

                            @if (!disableButtons) {
                            <mat-form-field class="fullLength">
                                <mat-label>Add Comments/Notes</mat-label>
                                <textarea matInput formControlName="comments"></textarea>
                            </mat-form-field>
                            }

                            @if (CheckedByPartner) {
                            <div class="fullLength">
                                <mat-checkbox formControlName="isPartnerCertified">I certify that<span class="important">*</span></mat-checkbox>
                                <ul>
                                    <li>The information contained in this form has been verified by me and is accurate.</li>
                                    <li>This receipt is in accordance with the Accounts Policy (including Direct Policy)* and Sanctions Policy.</li>
                                    <li>I have undertaken source of funds checks and that they are satisfactory.</li>
                                </ul>
                                <p>If any doubt, please contact a senior member of the Compliance Team.</p>
                            </div>
                            }
                        </div>
                    </div>
                </mat-tab>

                <mat-tab label="Attachments" [disabled]="!hasAttachments">
                    <div [ngClass]="{
                            'tab-content-wrapper-return': isDialogOpen() && showReturnReason,
                            'tab-content-wrapper': isDialogOpen() && !showReturnReason,
                            'extended-tab-content-return-wrapper': !isDialogOpen() && showReturnReason,
                            'extended-tab-content-wrapper': !isDialogOpen() && !showReturnReason
                         }">
                        <xp-attachment-list *ngIf="hasAttachments" [attachments]="expectFundData.documents" />
                    </div>
                </mat-tab>

                <mat-tab label="Audit">
                    <xp-audit-log [ngClass]="{
                            'dialog-mode-rejected': isDialogOpen() && showReturnReason,
                            'dialog-mode': isDialogOpen() && !showReturnReason,
                            'extended-mode-rejected': !isDialogOpen() && showReturnReason,
                            'extended-mode': !isDialogOpen() && !showReturnReason
                         }"
                                  [requestId]="getRequestId" [requestType]="RequestType.ExpectFunds" [showPaginator]="false" />
                </mat-tab>
            </mat-tab-group>
        </form>
    </div>

    <div mat-dialog-actions class="action-buttons">
        <div class="left-buttons">
            <button type="button" [disabled]="!hasAttachments" (click)="downloadDocuments(expectFundData.id, 'Expect Fund')"
                    mat-raised-button color="accent" matTooltip="Download documents">
                Download Attachments
            </button>
        </div>
        <div [class.right-buttons]="!isDialogOpen()">
            <button type="button" [disabled]="disableButtons || ExpectFundForm.invalid" (click)="approveRequest()"
                    mat-raised-button color="accent">
                {{ approveBtn }}
            </button>

            @if (previousStages.length === 0) {
            <button type="button" [disabled]="disableButtons" (click)="delete()" mat-raised-button color="warn">
                Reject
            </button>
            } @else {
            <button type="button" [disabled]="disableButtons" mat-raised-button [matMenuTriggerFor]="rejectMenu" color="warn">
                Reject
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #rejectMenu="matMenu">
                @for (previousStage of previousStages; track previousStage.stageOrder) {
                <span [matTooltip]="isReturnDisabled(previousStage.stageOrder) ? 'This request must be returned to the Accounts team for reversal.' : ''"
                      matTooltipPosition="right"
                      matTooltipShowDelay="300">
                    <button mat-menu-item
                            [disabled]="isReturnDisabled(previousStage.stageOrder)"
                            (click)="returnRequest(previousStage.stageOrder, previousStage.rejectStatus || 'Return')">
                        {{ previousStage.rejectStatus }}
                    </button>
                </span>
                }
                <mat-divider></mat-divider>
                <button mat-menu-item [disabled]="disableAtStage4" (click)="delete()">
                    Reject
                </button>
            </mat-menu>
            }
        </div>
    </div>
</div>
}
